module.exports = __webpack_public_path__ + "static/media/outstanding-invoices.d3aaff28.svg";